import React, { useState, useEffect } from "react";
import { Row, Col, Form, Button, Accordion, Spinner } from "react-bootstrap";
import { FormattedMessage, useIntl } from "react-intl";
import { ArrowCounterclockwise, CheckLg } from "react-bootstrap-icons";
import { useSelector, useDispatch } from "react-redux";
import { actions as actionStep } from "../../../reducers/Step";
import { actions as actionStepTwo, getContractNo, getTotal } from "../../../reducers/StepTwo";
import { actions as actionStepOne } from "../../../reducers/StepOne";
import { actions as actionPay, getData, getIndexCheck } from "../../../reducers/StepPay";
import { Alert } from "../../Alerts";
import FAMSA from "../../../config/constants";
import axios from "axios";
import { normalizeInput, currencyFormatter } from "../../generals/normalizaInput";
import CurrencyField from "../../generals/Fields/CurrencyField";
import Loading from "../../Loading";
import { getTypePay } from "../../../reducers/TypePayment";
import { faLessThanEqual } from "@fortawesome/free-solid-svg-icons";
import { getLang } from '../../../reducers/lang'; 

const AccordionFamsa = () => {
    const intl = useIntl();
    const distpatch = useDispatch();
    const ContractNo = useSelector(getContractNo);
    const type_pay = useSelector(getTypePay);
    const DataPay = useSelector(getData);
    const indexCheck = useSelector(getIndexCheck);
    const total = useSelector(getTotal);
    const [otherValue, setOtherValue] = useState(0);
    const sLang = useSelector(getLang);
    
    const handlePastDueAmt = (event, index) => {
        distpatch(actionPay.setIndexCheck(index));
        let values = [...DataPay];
        let auxobject = { ...values[index] };
        auxobject.checkPastDue = event.target.checked;
        values[index] = auxobject;
        distpatch(actionPay.setData(values));
        let overall = (event.target.checked) ? auxobject.PastDueAmt : -(auxobject.PastDueAmt);
        distpatch(actionStepTwo.setTotal(parseFloat(total) + overall));
    }

    const handleContractPayOff = (event, index) => {
        distpatch(actionPay.setIndexCheck(index));
        let values = [...DataPay];
        let auxobject = { ...values[index] };
        auxobject.checkContractOff = event.target.checked;
       /* if(!event.target.checked){
            distpatch(actionStepTwo.setTotal(parseFloat(total) - parseFloat(values[index].PayOff)));
        }else{
            distpatch(actionStepTwo.setTotal(parseFloat(values[index].PayOff)))
        }*/
        //debugger
        let auxtotal = 0;
        let auxtotall = parseFloat(total);
        if(auxobject.checkPastDue){
            let pastdue = parseFloat(total) - parseFloat(values[index].PastDueAmt);
            auxtotall = pastdue
            //distpatch(actionStepTwo.setTotal(auxtotal))
        }
        if(auxobject.checkCurrentMon){
            let currentmont = parseFloat(total) - parseFloat(values[index].CurrentDueAmt);
            auxtotall = currentmont
            //distpatch(actionStepTwo.setTotal(auxtotal))
        }
        if(auxobject.checkOther){
            let othervalue = parseFloat(total) - parseFloat(values[index].otherValue);
            auxtotall = othervalue
            //distpatch(actionStepTwo.setTotal(auxtotal))
        }
        let overall = (event.target.checked) ? auxobject.PayOff : -(auxobject.PayOff);
        auxtotal = auxtotall + overall
       /* if(auxobject.checkContractOff){
            let overall = (event.target.checked) ? auxobject.PayOff : -(auxobject.PayOff);
            auxtotal = parseFloat(total) + overall
        }
        if(!auxobject.checkContractOff){
            let overall = -(auxobject.PayOff);
            auxtotal = parseFloat(total) + overall
        }*/
        auxobject.checkOther = false;
        auxobject.checkCurrentMon = false;
        auxobject.checkPastDue = false;
        values[index] = auxobject;
        //distpatch(actionPay.setData(values));
       /* let overall = (event.target.checked) ? auxobject.PayOff : -(auxobject.PayOff);
        let auxtotal = parseFloat(total) + overall*/
        distpatch(actionStepTwo.setTotal(auxtotal));
        distpatch(actionPay.setData(values));
        /*let overall = (event.target.checked) ? auxobject.PayOff : -(auxobject.PayOff);
        let auxtotal = parseFloat(total) + overall
        distpatch(actionStepTwo.setTotal(auxtotal));*/
    }

    const handleCurrentMonPay = (event, index) => {
        //debugger
        distpatch(actionPay.setIndexCheck(index));
        let values = [...DataPay];
        let auxobject = { ...values[index] };
        auxobject.checkCurrentMon = event.target.checked;
        values[index] = auxobject;
        /*if(!event.target.checked){
            distpatch(actionStepTwo.setTotal(parseFloat(total) - parseFloat(values[index].CurrentDueAmt)));
        }else{
            distpatch(actionStepTwo.setTotal(parseFloat(values[index].CurrentDueAmt)))
        }*/
        distpatch(actionPay.setData(values));
        let overall = (event.target.checked) ? auxobject.CurrentDueAmt : -(auxobject.CurrentDueAmt);
        let auxtotal = parseFloat(total) + overall
        distpatch(actionStepTwo.setTotal(auxtotal));
    }

    const handleOther = (event, index) => {
       //debugger
        distpatch(actionPay.setIndexCheck(index));
        let values = [...DataPay];
        let auxobject = { ...values[index] };
        auxobject.checkOther = event.target.checked;
        if(!event.target.checked){
            distpatch(actionStepTwo.setTotal(parseFloat(total) - parseFloat(values[index].otherValue)));
        }
        if(auxobject.checkPastDue){
            distpatch(actionStepTwo.setTotal(parseFloat(total) - parseFloat(values[index].PastDueAmt)));
        }
        if(auxobject.checkCurrentMon){
            distpatch(actionStepTwo.setTotal(parseFloat(total) - parseFloat(values[index].CurrentDueAmt)));
        }
        if(auxobject.checkContractOff){
            distpatch(actionStepTwo.setTotal(parseFloat(total) - parseFloat(values[index].PayOff)));
        }
        auxobject.otherValue = 0;
        auxobject.checkPastDue = false;
        auxobject.checkContractOff = false;
        auxobject.checkCurrentMon = false;
        values[index] = auxobject;
        distpatch(actionPay.setData(values));
    }

    const handleInput = (value, index) => {
        //debugger
        let values = [...DataPay];
        let auxobject = { ...values[index] };
        if(DataPay.length > 1){
            let overall = 0 //(auxobject.checkOther) ? parseFloat(value) : -parseFloat(value);
            
           if((parseFloat(total) > parseFloat(value)) && values[index].otherValue !== 0){
                overall = parseFloat(total) - parseFloat(value);
           }else if((parseFloat(value) > parseFloat(total)) && values[index].otherValue !== 0){
                overall = parseFloat(total) + parseFloat(value);
           }else{
                overall = parseFloat(value) + parseFloat(total);
           }
            distpatch(actionStepTwo.setTotal(overall));
        }else{
            distpatch(actionStepTwo.setTotal(parseFloat(value)));
        }
        distpatch(actionPay.setIndexCheck(index));
        auxobject.otherValue = value;
        values[index] = auxobject;
        distpatch(actionPay.setData(values));
        setOtherValue(value);
    }

    const handleInputChange = (value) => {
        //  setOtherValue(value);
    }

    return (
        <>
            {DataPay?.map((value, index) => (
                /*<Accordion key={`Accordion-${index}`} defaultActiveKey={(type_pay === 2) ? `Detail-${index}` : `Detail-${index}`} flush>
                    <Accordion.Item eventKey={`Detail-${index}`}>
                        <Accordion.Header className="accordion-header bg-secondary "><b className="text-dark"><FormattedMessage id="step.two.contract.number" />: {value.ContractNo}</b></Accordion.Header>
                        <Accordion.Body>*/
                <div className="card border-light mb-3">
                    <div className="card-header">
                        <b className="text-dark"><FormattedMessage id="step.two.contract.number" />: {value.ContractNo}</b>
                    </div>
                    <div className="card-body">
                            <Row className="justify-content-center">
                                <Col md={{ span: 4 }} sm={{ span: 5 }}>
                                    <Form.Group className="mb-3 justify-content-center mx-3 my-4">
                                        <b className="text-muted">
                                            <Form.Check
                                                type="checkbox" isValid
                                                id={`pastdue-1${index}`}
                                                value={`pastdue-1${index}`}
                                                label={intl.formatMessage({ id: "step.two.radiobtn1" })}
                                                checked={value.checkPastDue}
                                                disabled={(value.checkOther) ? true : (value.checkContractOff) ? true : false}
                                                onChange={(e) => handlePastDueAmt(e, index)}
                                            >
                                            </Form.Check>
                                        </b>
                                    </Form.Group>
                                </Col>
                                <Col className='border-bottom text-center my-3' md={{ span: 3, offset: 1 }} sm={{ span: 4 }}><b className={`${(value.PastDueAmt > 0) ? "famsa-text-red" : ""}`}><FormattedMessage id="step.two.duenow" /></b></Col>
                                <Col className="border-bottom text-end my-3" md={{ span: 3, offset: 1 }} sm={{ span: 4 }}><p>{currencyFormatter({ currency: "USD", value: value.PastDueAmt })}</p></Col>
                            </Row>
                            <Row className="justify-content-center">
                                <Col md={{ span: 4 }} sm={{ span: 5 }}>
                                    <Form.Group className="mb-3 justify-content-center mx-3 my-4">
                                        <b className="text-muted">
                                            <Form.Check
                                                type="checkbox" isValid
                                                id={`currentmon-2${index}`}
                                                value={`currentmon-2${index}`}
                                                label={intl.formatMessage({ id: "step.two.radiobtn2" })}
                                                checked={value.checkCurrentMon}
                                                disabled={(value.checkOther) ? true : (value.checkContractOff) ? true : false}
                                                onChange={(e) => handleCurrentMonPay(e, index)}
                                            /></b>
                                    </Form.Group>
                                </Col>
                                {(sLang === 'en-US') ? <>
                                    <Col className="border-bottom text-center my-3" md={{ span: 3, offset: 1 }} sm={{ span: 4 }}>
                                        <p>{value.CurrentDueDate}</p>
                                    </Col>
                                    </> : 
                                    <Col className="border-bottom text-center my-3" md={{ span: 3, offset: 1 }} sm={{ span: 4 }}>
                                        <p>{value.CurrentDueDateSpa}</p>
                                    </Col>
                                }
                                <Col className="border-bottom text-end my-3" md={{ span: 3, offset: 1 }} ><p>{currencyFormatter({ currency: "USD", value: value.CurrentDueAmt })}</p></Col>
                            </Row>
                            <Row className="justify-content-center">
                                <Col md={{ span: 4 }} sm={{ span: 5 }}>
                                    <Form.Group className="mb-3 justify-content-center mx-3 my-4">
                                        <b className="text-muted">
                                            <Form.Check
                                                type="checkbox" isValid
                                                id={`contractoff-3${index}`}
                                                value={`contractoff-3${index}`}
                                                label={intl.formatMessage({ id: "step.two.radiobtn3" })}
                                                checked={value.checkContractOff}
                                                disabled={(value.checkOther) ? true : (value.checkCurrentMon && value.checkPastDue) ? true : false}
                                                onChange={(e) => handleContractPayOff(e, index)}
                                            /></b>
                                    </Form.Group>
                                </Col>
                                {(sLang === 'en-US') ? <>
                                    <Col className="border-bottom text-center my-3" md={{ span: 3, offset: 1 }} sm={{ span: 4 }}>
                                        <p>{value.PayOffDate}</p>
                                    </Col>
                                    </> : 
                                    <Col className="border-bottom text-center my-3" md={{ span: 3, offset: 1 }} sm={{ span: 4 }}>
                                        <p>{value.PayOffDateSpa}</p>
                                    </Col>
                                }
                                <Col className="border-bottom text-end my-3" md={{ span: 3, offset: 1 }} ><p>{currencyFormatter({ currency: "USD", value: value.PayOff })}</p></Col>
                            </Row>
                            <Row className="justify-content-start">
                                <Col md={{ span: 4 }} sm={{ span: 5 }}>
                                    <Form.Group className="mb-3 justify-content-center mx-3 my-4">
                                        <b className="text-muted">
                                            <Form.Check
                                                type="checkbox" isValid
                                                id={`other-4${index}`}
                                                value={`other-4${index}`}
                                                label={intl.formatMessage({ id: "step.two.radiobtn4" })}
                                                checked={value.checkOhter}
                                                disabled={(value.checkCurrentMon && value.checkPastDue) ? true : (value.checkContractOff) ? true : false}
                                                onChange={(e) => handleOther(e, index)}
                                            /></b>
                                    </Form.Group>
                                </Col>
                                <Col md={{ span: 3, offset: 1 }} sm={{ span: 4 }}><p></p></Col>
                                {(value.checkOther) ?
                                    <Col className="text-end p-0" md={{ span: 3, offset: 1 }}>
                                        <Form.Group controlId="exampleForm.ControlInput1" >
                                            <CurrencyField
                                                id={`input-5${index}`}
                                                defaultValue={value.otherValue}
                                                className={`text-end p-2 famsa-btn-w famsa-border-input-blue`}
                                                onChange={(value) => handleInput(value, index)}
                                                onInputChange={handleInputChange}
                                            />
                                        </Form.Group>
                                    </Col>
                                    : null}
                            </Row>
                            {(type_pay === 2) ?
                                <Row>
                                    <Col md={{ span: 4 }} sm={{ span: 5 }}>
                                        <Form.Group className="mb-3 justify-content-center mx-3 my-4">
                                            <b className="text-muted">
                                                <Form.Check
                                                    type="checkbox"
                                                    id="transactioncheck"
                                                    value={1}
                                                    label={intl.formatMessage({ id: "step.two.label.note" }) + currencyFormatter({ currency: "USD", value: FAMSA.SERVER.TRANSACTION }) + intl.formatMessage({ id: "step.two.note" })}
                                                    checked={1}
                                                    disabled={true}
                                                /></b>
                                        </Form.Group>
                                    </Col>
                                    <Col md={{ span: 3, offset: 1 }} sm={{ span: 4 }}><p></p></Col>
                                    <Col className="border-bottom text-end my-3" md={{ span: 3, offset: 1 }} ><p>{currencyFormatter({ currency: "USD", value: FAMSA.SERVER.TRANSACTION })}</p></Col>
                                </Row>
                            : null}
                        </div>
                    </div>
            ))}
        </>
    );
}

export default AccordionFamsa;